import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import * as Sentry from "@sentry/angular";

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private ngZone: NgZone, private http: HttpClient) {}

  handleError(error: any): void {
    try {
        // Log the error to the console
        console.error('An unexpected error occurred:', error);

        // Enviar erro para o Sentry
        Sentry.captureException(error, {
          tags: {
            source: 'GlobalErrorHandler'
          },
          extra: {
            errorDetails: error
          }
        });


        // Display a user-friendly error message
        this.ngZone.run(() => {
          alert('Ops, um erro inesperado aconteceu. Tente novamente.');
        });
    }
    catch (error) {
      console.error('An error occurred while handling the error:', error);
      // Se houver erro no próprio handler, também enviamos para o Sentry
      Sentry.captureException(error, {
        tags: {
          source: 'GlobalErrorHandler',
          context: 'ErrorHandlerFailure'
        }
      });
    }
  }
}
